__turbopack_context__.v({
  "famousFrom": "insurances_and_famousFrom-module-scss-module__utXkpa__famousFrom",
  "insurances": "insurances_and_famousFrom-module-scss-module__utXkpa__insurances",
  "logoCarouselFamousFrom": "insurances_and_famousFrom-module-scss-module__utXkpa__logoCarouselFamousFrom",
  "logoSvg": "insurances_and_famousFrom-module-scss-module__utXkpa__logoSvg",
  "logos": "insurances_and_famousFrom-module-scss-module__utXkpa__logos",
  "logosScrollable": "insurances_and_famousFrom-module-scss-module__utXkpa__logosScrollable",
  "threeLineEllipse": "insurances_and_famousFrom-module-scss-module__utXkpa__threeLineEllipse",
});
